import { render } from "./ProviderToSeller.vue?vue&type=template&id=7d1abe31&scoped=true"
import script from "./ProviderToSeller.vue?vue&type=script&lang=js"
export * from "./ProviderToSeller.vue?vue&type=script&lang=js"

import "@/assets/css/components/commonPopup.css?vue&type=style&index=0&id=7d1abe31&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d1abe31"]])

export default __exports__